import * as React from "react";

import primaryColour from "../constants";

function SvgService(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;

  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.25 7.5H22.1895C21.9975 7.5 21.8055 7.5735 21.6585 7.719L17.379 12H15.621L12 8.379V6.621L16.281 2.34C16.4265 2.1945 16.5 2.0025 16.5 1.8105V0.75C16.5 0.336 16.164 0 15.75 0H10.1895C9.9975 0 9.8055 0.0735 9.6585 0.219L4.719 5.1585C4.5735 5.3055 4.5 5.4975 4.5 5.6895V12.879L0.219 17.16C0.0735 17.3055 0 17.4975 0 17.6895V18.3105C0 18.5025 0.0735 18.6945 0.219 18.8415L5.1585 23.781C5.3055 23.9265 5.4975 24 5.6895 24H6.3105C6.5025 24 6.6945 23.9265 6.8415 23.781L11.121 19.5H18.3105C18.5025 19.5 18.6945 19.4265 18.8415 19.281L23.781 14.3415C23.9265 14.1945 24 14.0025 24 13.8105V8.25C24 7.836 23.664 7.5 23.25 7.5Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgService;
